import React, { useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import { MyContextSupply } from "../../Context";
import axios from "axios";
import { toast } from "react-toastify";

const WriteReview = ({
  isWriteReviewTrue,
  setIsWriteReviewTrue,
  id,
  inddata,
  setIndedata,
}) => {
  const { token, account } = MyContextSupply();
  const [reviewInfo, setReviewInfo] = useState({
    rating: 0,
    comment: "",
  });

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };
  const { fname: userName } = account !== undefined && account;

  const { rating, comment } = reviewInfo;

  const OnChangeInputsReview = (e) => {
    const { name, value } = e.target;
    setReviewInfo((previousValues) => {
      return { ...previousValues, [name]: value };
    });
  };
  const OnSubmitReview = async (e) => {
    e.preventDefault();
    if (rating === 0 && comment === "" && userName === undefined) {
      toast.warn(
        "Can't submit the review, please fill all the inputs",
        toastStyle
      );
    } else {
      await axios
        .put(
          "https://stechbackend-9r4c.onrender.com/product/write/new/review",
          {
            id,
            userName,
            rating,
            comment,
          },
          { headers: { Authorization: token }, withCredentials: true }
        )
        .then((res) => {
          if (res.status === 201) {
            toast.success(res.data.message, toastStyle);
            const updateReviewArray = [...inddata.review, res.data.review];
            setIndedata((prev) => {
              return { ...prev, review: updateReviewArray };
            });
            setReviewInfo({
              rating: 0,
              comment: "",
            });
            setIsWriteReviewTrue(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  //   console.log(rating, typeof rating);
  //   console.log(account);
  //   console.log(fname);

  return (
    <div
      className={`WriteReviewFixed ${
        isWriteReviewTrue && "WriteReviewFixed-show"
      }`}
    >
      <div
        className={`review-form-div ${
          isWriteReviewTrue && "review-form-div-show"
        }`}
      >
        <button
          onClick={() => setIsWriteReviewTrue(false)}
          className="write-review-close-btn"
        >
          <AiOutlineCloseCircle className="btn-close-cart-ani" />
        </button>
        <form onSubmit={OnSubmitReview} className="form-review">
          <h3 className="review_h3">Write Your Review</h3>
          <label htmlFor="rating">Rating:</label>
          <Stack spacing={1} sx={{ width: "fit-content" }}>
            <Rating
              name="rating"
              value={Number(rating)}
              onChange={OnChangeInputsReview}
              size="large"
            />
          </Stack>
          <div>
            <label htmlFor="comment">Comment:</label>
          </div>
          <textarea
            name="comment"
            value={comment}
            onChange={OnChangeInputsReview}
            className="review-submit-text-area"
          />
          <button type="submit" className="btn-review-submit">
            Submit
          </button>
          {/* if not logged in then show this */}
          {token.length === 0 && (
            <div className="if-not-logged-in-show-write-review-above">
              <div>
                <p>You're not logged in yet!</p>
                <p>To Write a Review</p>
                <p>
                  Please:
                  <Link to="/login" className="review-navigate-login-btn">
                    Login
                  </Link>
                </p>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default WriteReview;
